import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API




export const getRutes = (params, setData) => {

    api.get(`${apiUrl}/monitor/programacion/rutas?activos=${params.activos}&cliente=${params.cliente}`)
        .then((res) => {
            setData(res.data)
        })
        .catch((error) => {
            console.log("getRutes error", error);

        })

}
export const getTipoServicios = (setServicios) => {

    api.get(`${apiUrl}/monitor/getTipoServicios`)
        .then((res) => {
            setServicios(res.data)
        })
        .catch((error) => {
            console.log("getTipoServicios error", error);

        })

}
export const getAllClients = (setClientes) => {

    api.get(`${apiUrl}/monitor/getAllClientsWithInactives`)
        .then((res) => {
            setClientes(res.data)
        })
        .catch((error) => {
            console.log("getAllClients", error);

        })

}
export const getClients = (setClientes) => {

    api.get(`${apiUrl}/monitor/getClients`)
        .then((res) => {
            setClientes(res.data)
        })
        .catch((error) => {
            console.log("getAllClients", error);

        })

}
export const getAllOperadores = (setOperadores) => {

    api.get(`${apiUrl}/monitor/getAllOperadores`)
        .then((res) => {
            setOperadores(res.data)
        })
        .catch((error) => {
            console.log("getRutes error", error);

        })

}
export const getEstructuras = async (id_ruta) => {

   const res = await api.get(apiUrl + `/monitor/getEstrucuraByIdRoute?id_ruta=${id_ruta}`)
   return res.data
}
export const getBitacorasAEliminar = async (id_ruta) => {

   const res = await api.get(apiUrl + `/monitor/programacion/bitacoras-a-eliminar?id_ruta=${id_ruta}`)
   return res.data
}
export const updateRuta = (params,setVisible,setActualizar,actualizar) => {

    api.patch(`${apiUrl}/monitor/programacion/edit_rutas`,params)
        .then((res) => {
            Swal.fire({
                icon: 'success',   // Icono de error
                title: 'Actualizado correctamente', // Título de la alerta
            });
            setVisible(false)
            setActualizar(!actualizar)
        })
        .catch((error) => {
            console.log("getRutes error", error);

        })

}
export const addRuta = (params,setVisible,setActualizar,actualizar) => {

    api.post(`${apiUrl}/monitor/programacion/add_rutas`,params)
        .then((res) => {
            Swal.fire({
                icon: 'success',   // Icono de error
                title: 'Agregado correctamente', // Título de la alerta
            });
            setVisible(false)
            setActualizar(!actualizar)
        })
        .catch((error) => {
            console.log("getRutes error", error);

        })

}